import request from '@/utils/request'

//获取角色表格数据
export function autoRoleList(data) {
  return request({
    url: '/admin_role/v1/list',
    method: 'post',
    data
  })
}

//新增角色数据
export function addRole(data) {
  return request({
    url: '/admin_role/v1/add',
    method: 'post',
    data
  })
}

//删除角色数据
export function deleteRole(data) {
  return request({
    url: '/admin_role/v1/delete',
    method: 'get',
    params: data
  })
}

//编辑角色数据
export function editRole(data) {
  return request({
    url: '/admin_role/v1/edit',
    method: 'post',
    data
  })
}
//编辑角色数据
export function editCount(data) {
  return request({
    url: '/admin_role/v1/editCount',
    method: 'post',
    data
  })
}

//所有角色数据
export function allRoleList(data) {
  return request({
    url: '/admin_role/v1/listAll',
    method: 'post',
    data
  })
}

//查看单个角色数据
export function singleRole(data) {
  return request({
    url: '/admin_role/v1/detail',
    method: 'get',
    params: data
  })
}
